import React, { useContext } from "react";
import styled from "styled-components";
import { DataUrlStoreContext } from "../loadData";

const PaginatorButton = ({ onClick, current, children }) => {
    if (current) {
        return <div
            className="scp-py-2 scp-px-4 scp-shadow-md scp-embed-block scp-rounded-sm scp-embed-paginator-button  scp-embed-paginator-button-current-page"
        >{children}</div>
    } else {
        return <a
            className="scp-py-2 scp-px-4 scp-cursor-pointer scp-shadow-md scp-embed-block scp-rounded-sm scp-embed-paginator-button"
            onClick={onClick}
        >{children}</a>
    }

}

const SepContainer = styled.div`
  display: flex;
`;
const Sep = styled.div`
  margin-left: 2px;
  &:last-child {
    margin-right: 2px;
  }
  border-right: 1px solid #EEE;
`;

const Separator = () => <div className="scp-w-2"></div>

export const Paginator = () => {
    const DataUrlStore = useContext(DataUrlStoreContext);
    const { page, count, total, data_url } = DataUrlStore.useState(state => ({
        page: state.page,
        count: state.count,
        total: state.total,
        data_url: state.next_data_url,
    }));
    if (total === null) {
        return null;
    }
    if (total <= count) {
        return null;
    }


    const totalPages = Math.floor(total / count) + 1;

    const setPage = function (n) {
        DataUrlStore.update(function (state) {
            state.data_url = data_url;
            state.page = n;
        })
    };

    const pages = [];


    // left side
    let leftEnd = 2;
    if (leftEnd > totalPages - 1) {
        leftEnd = totalPages - 1;
    }
    for (let i = 0; i <= leftEnd; i++) {
        pages.push(<PaginatorButton current={i === page} onClick={() => setPage(i)}
            key={i}>{i + 1}</PaginatorButton>)
    }


    // middle side
    let middleStart = page - 1;
    let middleEnd = middleStart + 2;
    if (middleStart > leftEnd + 1) {
        // insert separator
        pages.push(<Separator key="sep1" />)
    }
    if (middleStart <= leftEnd) {
        middleStart = leftEnd + 1;
    }
    if (middleEnd > totalPages - 1) {
        middleEnd = totalPages - 1;
    }

    for (let i = middleStart; i <= middleEnd; i++) {
        pages.push(<PaginatorButton current={i === page} onClick={() => setPage(i)}
            key={i}>{i + 1}</PaginatorButton>)
    }

    // right side
    let rightStart = totalPages - 1 - 2;
    if (rightStart > middleEnd + 1) {
        // insert separator
        pages.push(<Separator key="sep2" />)
    }
    if (rightStart <= middleEnd) {
        rightStart = middleEnd + 1;
    }
    for (let i = rightStart; i < totalPages; i++) {
        pages.push(<PaginatorButton current={i === page} onClick={() => setPage(i)}
            key={i}>{i + 1}</PaginatorButton>)
    }


    return <div className="scp-flex scp-gap-2 scp-justify-center">
        {page > 0 &&
            <PaginatorButton onClick={() => setPage(page - 1)}>«</PaginatorButton>}
        {pages}
        {page < totalPages - 1 &&
            <PaginatorButton onClick={() => setPage(page + 1)}>»</PaginatorButton>}
    </div>
}